import React from "react";
import { useTheme } from "./hooks/useTheme";

interface CvvValidateProps {
  value: string;
  setValue: (value: string) => void;
  className?: any;
}

const CvvValidate = ({ value, setValue, className }: CvvValidateProps) => {
const { themeStyles } = useTheme();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setValue(value);
    const isValid = /^\d{3,4}$/gm.test(value);
    e.target.setCustomValidity(
      isValid ? "" : "Please enetr a valid cvv number"
    );
  };

  return (
    <>
      <label className={`block text-xs font-medium ${themeStyles.form.tailwindLabelTextColor} text-left`}>CVV</label>
      <input
        name="cvv"
        type="text"
        maxLength={4}
        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
        required
        value={value}
        onChange={handleChange}
      />
    </>
  );
};

export default CvvValidate;